// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type InstanceUserPut,
  InstanceUserPutFromJSON,
  InstanceUserPutToJSON,
} from "../models/InstanceUserPut";
import {
  type InstanceUserRead,
  InstanceUserReadFromJSON,
  InstanceUserReadToJSON,
} from "../models/InstanceUserRead";
import {
  type PageInstanceUserRead,
  PageInstanceUserReadFromJSON,
  PageInstanceUserReadToJSON,
} from "../models/PageInstanceUserRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface InstanceUserDeleteRequest {
  /**
   *
   */
  id: string;
}

export interface InstanceUserPutRequest {
  /**
   *
   */
  id: string;
  /**
   *
   */
  instanceUserPut: InstanceUserPut;
}

/**
 *
 */
export class InstanceUsersApi extends runtime.BaseAPI {
  /**
   * Creates request options for instancePermissions without sending the request
   */
  async instancePermissionsRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/instance-permissions`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * show instance-level permissions
   */
  async instancePermissionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: boolean | null }>> {
    const requestOptions = await this.instancePermissionsRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * show instance-level permissions
   */
  async instancePermissions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: boolean | null }> {
    const response = await this.instancePermissionsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for instanceUserDelete without sending the request
   */
  async instanceUserDeleteRequestOpts(
    requestParameters: InstanceUserDeleteRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling instanceUserDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/instance-users/{id}`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * remove instance-level role assignment
   */
  async instanceUserDeleteRaw(
    requestParameters: InstanceUserDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.instanceUserDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * remove instance-level role assignment
   */
  async instanceUserDelete(
    requestParameters: InstanceUserDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.instanceUserDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for instanceUserList without sending the request
   */
  async instanceUserListRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/instance-users`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * show instance-level role assigments
   */
  async instanceUserListRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageInstanceUserRead>> {
    const requestOptions = await this.instanceUserListRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PageInstanceUserReadFromJSON(jsonValue)
    );
  }

  /**
   * show instance-level role assigments
   */
  async instanceUserList(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageInstanceUserRead> {
    const response = await this.instanceUserListRaw(initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for instanceUserPut without sending the request
   */
  async instanceUserPutRequestOpts(
    requestParameters: InstanceUserPutRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling instanceUserPut().'
      );
    }

    if (requestParameters["instanceUserPut"] == null) {
      throw new runtime.RequiredError(
        "instanceUserPut",
        'Required parameter "instanceUserPut" was null or undefined when calling instanceUserPut().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/instance-users/{id}`;
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: InstanceUserPutToJSON(requestParameters["instanceUserPut"]),
    };
  }

  /**
   * assign instance-level role
   */
  async instanceUserPutRaw(
    requestParameters: InstanceUserPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<InstanceUserRead>> {
    const requestOptions = await this.instanceUserPutRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InstanceUserReadFromJSON(jsonValue)
    );
  }

  /**
   * assign instance-level role
   */
  async instanceUserPut(
    requestParameters: InstanceUserPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<InstanceUserRead> {
    const response = await this.instanceUserPutRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
